import { graphql } from '@/gql';

export const UpdateSocPerformanceResultMutation = graphql(`
    mutation UpdateSocPerformanceResult($id: ObjectID!, $input: UpdateSocResultInput!) {
        updateSocResult(id: $id, input: $input) {
            ... on UpdateSocResultSuccessfulResponse {
                result {
                    ...SocPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
